import { extname } from '@gitbook/util-files';

import { parseUrl } from './parseUrl';

/**
 * Return the extension of the file targeted by a URL if any.
 */
export function getUrlFileExtension(inputUrl: string): string | null {
    const url = parseUrl(inputUrl);
    if (!url) {
        return null;
    }

    const ext = extname(url.pathname);
    return ext || null;
}
